(()=>{
  const toPositiveInt=(value)=>{
    const n=Number.parseInt(String(value??'').trim(),10);
    return Number.isSafeInteger(n)&&n>0?n:0;
  };

  function normalizeItems(items){
    if(!Array.isArray(items)) return [];
    return items.map(item=>({
      variant_id:toPositiveInt(item?.variant_id ?? item?.id),
      quantity:Math.max(1,toPositiveInt(item?.quantity)||1)
    })).filter(item=>item.variant_id>0);
  }

  function currentProductItem(root){
    let id=0;
    const productId=String(root.dataset.productId||'').trim();

    // 1) Horizon product-form-component for the product currently displayed.
    if(productId){
      const component=document.querySelector(`product-form-component[data-product-id="${CSS.escape(productId)}"]`);
      id=toPositiveInt(component?.querySelector('input[name="id"], [ref="variantId"]')?.value);
    }

    // 2) Any canonical Shopify product add form on the page.
    if(!id){
      const inputs=document.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"], form[action*="/cart/add"] input[name="id"], product-form-component [ref="variantId"]');
      for(const input of inputs){
        id=toPositiveInt(input.value);
        if(id) break;
      }
    }

    // 3) Shopify variant query string, when present.
    if(!id){
      id=toPositiveInt(new URLSearchParams(window.location.search).get('variant'));
    }

    // 4) Liquid-rendered fallback.
    if(!id){
      id=toPositiveInt(root.dataset.variantId);
    }

    let quantity=1;
    const qty=document.querySelector('form[data-type="add-to-cart-form"] input[name="quantity"], form[action*="/cart/add"] input[name="quantity"], input[name="quantity"]');
    if(qty) quantity=Math.max(1,toPositiveInt(qty.value)||1);

    return id?[{variant_id:id,quantity}]:[];
  }

  function staticCartItems(root){
    try{
      return normalizeItems(JSON.parse(root.querySelector('[data-tbi-items]')?.textContent||'[]'));
    }catch(_){
      return [];
    }
  }

  async function liveCartItems(root){
    try{
      const base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
      const res=await fetch(`${base}cart.js`,{headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store'});
      if(!res.ok) throw new Error('cart fetch failed');
      const cart=await res.json();
      const items=normalizeItems(cart?.items);
      if(items.length) return items;
    }catch(_){ /* fallback below */ }
    return staticCartItems(root);
  }

  async function resolveItems(root){
    return root.dataset.mode==='cart' ? liveCartItems(root) : currentProductItem(root);
  }

  function init(root){
    if(root.dataset.tbiInitialized==='1') return;
    root.dataset.tbiInitialized='1';

    const dialog=root.querySelector('[data-tbi-dialog]');
    const open=root.querySelector('[data-tbi-open]');
    const close=root.querySelector('[data-tbi-close]');
    const form=root.querySelector('[data-tbi-form]');
    const status=root.querySelector('[data-tbi-status]');
    if(!dialog||!open||!form) return;

    open.addEventListener('click',()=>dialog.showModal());
    close?.addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});

    form.addEventListener('submit',async e=>{
      e.preventDefault();
      const submit=form.querySelector('button[type="submit"]');
      submit.disabled=true;
      status.hidden=false;
      status.textContent='Se inițializează cererea tbi bank…';

      try{
        const fd=new FormData(form);
        const items=await resolveItems(root);
        if(!items.length){
          throw new Error(root.dataset.mode==='cart'
            ? 'Coșul este gol sau nu a putut fi citit. Reîncarcă pagina și încearcă din nou.'
            : 'Nu am putut identifica varianta activă a produsului. Selectează varianta și încearcă din nou.');
        }

        const shippingSel=form.querySelector('[name="shipping_option"]');
        const opt=shippingSel?.selectedOptions?.[0];
        const payload={
          items,
          instalments:toPositiveInt(fd.get('instalments')),
          shipping:{
            title:opt?.dataset.title||opt?.textContent||'Transport ARWAY',
            price:Number.parseFloat(opt?.dataset.price||'0')||0
          },
          customer:{
            fname:fd.get('fname'),
            lname:fd.get('lname'),
            cnp:fd.get('cnp')||'',
            email:fd.get('email'),
            phone:fd.get('phone'),
            shipping_address:fd.get('address'),
            shipping_city:fd.get('city'),
            shipping_county:fd.get('county'),
            billing_address:fd.get('address'),
            billing_city:fd.get('city'),
            billing_county:fd.get('county')
          }
        };

        const res=await fetch(root.dataset.endpoint,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify(payload)
        });
        const data=await res.json().catch(()=>({}));
        if(!res.ok||!data.ok) throw new Error(data.error||'Nu am putut porni finanțarea.');
        if(!data.redirect_url) throw new Error('Backend-ul nu a returnat URL-ul de continuare tbi bank.');

        status.textContent='Te redirecționăm către tbi bank…';
        window.location.assign(data.redirect_url);
      }catch(err){
        status.textContent=err?.message||'A apărut o eroare.';
        submit.disabled=false;
      }
    });
  }

  function initAll(){document.querySelectorAll('[data-arway-tbi]').forEach(init)}

  document.addEventListener('click',e=>{
    const trigger=e.target.closest?.('[data-tbi-cart-checkout-trigger]');
    if(!trigger) return;
    const root=document.querySelector('[data-arway-tbi][data-mode="cart"]');
    const dialog=root?.querySelector('[data-tbi-dialog]');
    if(dialog) dialog.showModal();
  });

  initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
